import { theme } from '@wix/social-groups-common/dist/src/components/ContentEditor/theme';

export default function() {
  return theme;
}
